import type { ErrorType } from '@/api/request'
import { formatAsTitle } from '@/utils/format'

interface UploadErrorItemType {
  errors: string[]
  properties: Record<string, UploadErrorItemType>
}

export interface UploadErrorsType extends ErrorType {
  items: UploadErrorItemType[]
}

const getRowPrefix = (error: string) => {
  return error.replace(/^Row\s*\d+:\s*/i, '')
}

const useUploadErrors = (uploadErrors?: UploadErrorsType) => {
  const errorItems = (uploadErrors?.items ?? []).reduce<{ row: number, errors: string[] }[]>((items, item, index) => {
    if (!item) {
      return items
    }

    const rowErrors: string[] = []
    item.errors?.forEach(error => {
      rowErrors.push(getRowPrefix(error))
    })

    Object.entries(item.properties ?? {}).forEach(([field, fieldError]) => {
      fieldError.errors?.forEach(error => {
        const clean = getRowPrefix(error)
        rowErrors.push(`${formatAsTitle(field)}: ${clean}`)
      })
    })

    items.push({
      row: index + 1,
      errors: rowErrors
    })

    return items
  }, [])

  const errorItemsCount = errorItems.length
  const errorMessage = errorItemsCount > 0
    ? `There ${errorItemsCount === 1 ? 'is' : 'are'} ${errorItemsCount} error${errorItemsCount === 1 ? '' : 's'} in your file.`
    : ''

  return { errorItems, errorMessage }
}


export default useUploadErrors
